export default "__VITE_ASSET__8yj0sDYQ__"